import React, { useState } from "react";
import Home from "./Home";
import App from "./App";
import "./App.css";

const Main = () => {
  const [gameParams, setGameParams] = useState(null);

  if (!gameParams) {
    return <Home onStart={setGameParams} />;
  }

  return (
    <App
      heroes={gameParams.heroes}
      heroLife={gameParams.heroLife}
      enemyLife={gameParams.enemyLife}
      bgColor={gameParams.bgColor}
      onRestartSetup={() => setGameParams(null)}
    />
  );
};

export default Main;
